import { alpha, ButtonBase, ButtonProps, Stack, Typography } from '@mui/material';
import { DownloadIcon } from '@shared/custom-icons';

interface AttachmentButtonProps extends ButtonProps {
  extension?: string;
  filename?: string;
  download?: string;
}

export default function AttachmentButton({
  children,
  extension,
  filename,
  sx,
  ...props
}: AttachmentButtonProps) {
  const resolvedExtension = extension ?? filename?.split('.').pop();

  return (
    <ButtonBase
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBlock: 2,
        marginInline: -1.5,
        paddingInline: 1.5,
        '&:hover,:focus': {
          boxShadow: ({ palette }) => `0 0 10px ${alpha(palette.common.black, 0.1)}`,
        },
        ...sx,
      }}
      {...props}
    >
      <Stack
        justifyContent={'space-between'}
        direction="row"
        alignItems="center"
        flexGrow={1}
        gap={1}
        sx={{
          '& > svg': {
            width: '16px',
          },
          '& > svg path': {
            fill: (theme) => theme.palette.primary.main,
          },
        }}
      >
        <Stack>
          <Typography
            variant="body2"
            component="span"
            textAlign="left"
            fontWeight={500}
            sx={{ color: (theme) => theme.palette.grey[900], marginBottom: 0.5 }}
          >
            {children}
          </Typography>
          <Typography
            variant="body3"
            component="span"
            textAlign="left"
            fontWeight={500}
            sx={{ color: (theme) => theme.palette.grey.A400 }}
          >
            .{resolvedExtension}
          </Typography>
        </Stack>
        <DownloadIcon />
      </Stack>
    </ButtonBase>
  );
}
